import React from 'react'
import PropTypes from 'prop-types'
import IcomoonReact from 'icomoon-react'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'

const TypeProps = {
  user: PropTypes.object
}

const UserIcons = ({ user, iconSize }) => {
  const userIcons = []
  if (user?.is_biz_card) {
    userIcons.push('Tick')
  }
  if (user?.is_speaker) {
    userIcons.push('Speaker')
  }
  if (user?.is_gb) {
    userIcons.push('GoverningBody')
  }
  return userIcons.map((icon) => {
    return (
      <IcomoonReact
        iconSet={rebrandIconSet}
        icon={icon}
        size={iconSize || 23}
        key={icon}
        className={generalStyles.mr10}
      />
    )
  })
}

UserIcons.propTypes = {
  ...TypeProps
}

export default UserIcons
